import React from 'react';
import { WixStyleReactEnvironmentProviderProps } from '.';

export const WixStyleReactEnvironmentContext =
  React.createContext<WixStyleReactEnvironmentProviderProps>({});
